const SvgVerified = () => {
  return (
    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_12083_55920)">
        <path
          d="M8.9998 2.2998C5.0236 2.2998 1.7998 5.5236 1.7998 9.4998C1.7998 13.476 5.0236 16.6998 8.9998 16.6998C12.976 16.6998 16.1998 13.476 16.1998 9.4998C16.1998 5.5236 12.976 2.2998 8.9998 2.2998ZM13.024 8.124L8.48801 12.66C8.37521 12.7728 8.2228 12.8358 8.0638 12.8358C7.9048 12.8358 7.7518 12.7728 7.6396 12.66L5.5678 10.5882C5.3332 10.3536 5.3332 9.9744 5.5678 9.7398C5.8024 9.5052 6.1816 9.5052 6.4162 9.7398L8.0638 11.3874L12.1756 7.27561C12.4102 7.04101 12.7894 7.04101 13.024 7.27561C13.2586 7.5102 13.2586 7.8894 13.024 8.124Z"
          fill="#27AE60"
        />
      </g>
      <defs>
        <clipPath id="clip0_12083_55920">
          <rect width="18" height="18" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgVerified;
